// extracted by mini-css-extract-plugin
export default {"maincontainer":"Delete_maincontainer__ksL3l","deletecard":"Delete_deletecard__hvAm1"};